import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { CheckboxComponent, TextFieldComponent } from "../../components/CustomFormElement";
import { AvatarFontIcon, ContactFontIcon, HomeAddressFontIcon } from "../../components/CustomIcons";
import CustomSection from "../../components/CustomSection";
import CustomUploadFile from "../../components/CustomUploadFile";
import theme from '../../theme.css';
import validators from "../../utils/validators";
import CustomCircularProgress from "../../components/CustomCircularProgress";

const useStyles = makeStyles((theme) => ({
    check_box: {
        padding: 0,
    },
    avatar: {
        verticalAlign: 'middle',
        width: theme.spacing(7),
        height: theme.spacing(7),
        borderRadius: '50%'
    }
}));

export default function HomeAddressView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { avatar, addressHome } = props;

    return (
        <CustomSection notMarginTop={true}
            title={t('home_rica_address_title')}
            icon={<HomeAddressFontIcon style={{
                color: theme.palette.common.white,
            }} />}
            customClass={classes.customClass}
        >
            <Grid item xs={12}>
                <Typography variant='body1'>{t('home_rica_address_desc_1')}</Typography>
            </Grid>
            <Grid item xs={12} marginTop={2}>
                <Typography variant='body1'>{t('home_rica_address_desc_2')}</Typography>
            </Grid>
            {props.addressLoading && <CustomCircularProgress />}
            <Grid item xs={12} container direction='row' spacing={1}>
                <FormHomeAddressInfo t={t} classes={classes}
                    addressHome={addressHome}
                    contactInfo={props.contactInfo}
                    onSaveHomeAddress={props.onSaveHomeAddress}
                />
            </Grid>
        </CustomSection>
    );
}

function FormHomeAddressInfo(props) {
    const { t, classes, addressHome } = props;
    console.log("addressHome===", addressHome);

    return (
        <Form
            onSubmit={props.onSaveHomeAddress}
            initialValues={{ ...addressHome }}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item justify="center" alignItems="center">
                    {console.log("values form===", values)}
                    <Grid xs={12} item style={{ textAlign: 'center', width: '100%' }}>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="address_line_1"
                                component={TextFieldComponent}
                                label={t('address_line_1')}
                                placeholder={t('enter_address_line_1') + '*'}
                                validate={validators.composeValidators(validators.required)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                fullWidth
                                name="state_province_county"
                                label={t('state_province_county')}
                                component={TextFieldComponent}
                                validate={validators.composeValidators(validators.required)}
                                defaultValue={addressHome && addressHome.state_province_county ? addressHome.state_province_county : null}
                            />
                        </Grid>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="town_city"
                                label={t('address_towncity')}
                                component={TextFieldComponent}
                                placeholder={t('address_towncity') + '*'}
                                validate={validators.composeValidators(validators.required)}
                                defaultValue={addressHome && addressHome.town_city ? addressHome.town_city : null}
                            />
                        </Grid>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="postal_code"
                                label={t('address_postalcode')}
                                component={TextFieldComponent}
                                placeholder={t('address_postalcode') + '*'}
                                validate={validators.composeValidators(validators.required)}
                                defaultValue={addressHome && addressHome.postal_code ? addressHome.postal_code : null}
                            />
                        </Grid>
                        <Grid xs={12} item container direction='row' spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <Field
                                    fullWidth
                                    name="apartment_number"
                                    label={t('address_apartment_number')}
                                    component={TextFieldComponent}
                                    placeholder={t('address_apartment_number')}
                                    defaultValue={addressHome && addressHome.apartment_number ? addressHome.apartment_number : null}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Field
                                    fullWidth
                                    name="apartment_name"
                                    component={TextFieldComponent}
                                    label={t('address_apartment_name')}
                                    placeholder={t('address_apartment_name')}
                                    defaultValue={addressHome && addressHome.apartment_name ? addressHome.apartment_name : null}
                                />
                            </Grid>
                        </Grid>
                        <Grid xs={12} item marginTop={3}>
                            <Box style={{ textAlign: 'left' }}>
                                <Button variant="contained" color="primary" size='small' onClick={handleSubmit} className={classes.button}>{t('btn_update')}</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        />
    );
}